module.exports = __webpack_public_path__ + "static/img/bm.585b2c22.png";